export default __webpack_public_path__ + "static/media/icon-arrow-up.65f37d70.svg";